import { device } from '@/styles/common';
import { faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { AnimatedSpacerContainer, CenterFoldContainer, TitleText } from '../general/CenterFold';

type Props = {};

function EthereumWithdraw({}: Props) {
  return <UseMevETH />;
}

function UseMevETH() {
  return (
    <CenterFoldContainer>
      <TitleText>mevETH Legal Disclaimer</TitleText>
      <AnimatedSpacerContainer>
        <Legal>
          <p style={{ marginTop: '20px' }}>
            <span>
              <span>
                <span>
                  This disclaimer is intended to inform you of the risks associated with
                  participating in the mevETH.
                </span>
              </span>
            </span>
          </p>
          <p style={{ marginTop: '20px' }}>
            <span>
              <span>
                <span>Risks</span>
              </span>
            </span>
          </p>
          <ul>
            <li style={{ listStyleType: 'disc', marginTop: '20px' }}>
              <span>
                <span>
                  <span>
                    Volatility: The value of Ethereum and other cryptocurrency assets is highly
                    volatile and can fluctuate wildly. This means that the value of your staked ETH
                    could decrease significantly, and you could lose money.
                  </span>
                </span>
              </span>
            </li>
            <li style={{ listStyleType: 'disc' }}>
              <span>
                <span>
                  <span>
                    Smart contract risk: The mevETH uses smart contracts to manage the staking
                    process. Smart contracts are complex pieces of code, and there is always the
                    risk of bugs or security vulnerabilities. If a smart contract is exploited, it
                    could result in the loss of your staked ETH.
                  </span>
                </span>
              </span>
            </li>
            <li style={{ listStyleType: 'disc' }}>
              <span>
                <span>
                  <span>
                    Liquid staking risk: Liquid staking allows you to stake your ETH and receive a
                    liquid representation of your staked ETH, which can be traded or sold. However,
                    liquid staking introduces additional risks, such as the risk of the liquid
                    staking provider becoming insolvent or the risk of the liquid staking token
                    being depegged from ETH.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p>
            <span>
              <span>
                <span>Disclaimer</span>
              </span>
            </span>
          </p>
          <p style={{ marginTop: '20px' }}>
            <span>
              <span>
                <span>
                  mevETH is not a financial instrument or investment product. It is a software
                  protocol that allows users to stake their ETH. The mevETH team does not provide
                  any financial advice or investment recommendations.
                </span>
              </span>
            </span>
          </p>
          <p style={{ marginTop: '20px' }}>
            <span>
              <span>
                <span>
                  By participating in mevETH, you acknowledge and understand the risks involved. You
                  agree to be solely responsible for any losses or damages that you may incur.
                </span>
              </span>
            </span>
          </p>
          <p>
            <span>
              <span>
                <span>Additional Information</span>
              </span>
            </span>
          </p>
          <p style={{ marginTop: '20px' }}>
            <span>
              <span>
                <span>
                  The mevETH is open source software. The code is available for review on GitHub.
                </span>
              </span>
            </span>
          </p>

          <p style={{ marginTop: '20px' }}>
            <span>
              <span>
                <span>
                  If you have any questions or concerns about the mevETH MEV Protocol, please do not
                  hesitate to contact the team at info@mev.io.
                </span>
              </span>
            </span>
          </p>
          <p>&nbsp;</p>
        </Legal>
      </AnimatedSpacerContainer>
    </CenterFoldContainer>
  );
}
const Legal = styled.div`
  color: white;
  font-size: 18px;
  line-height: 20px;

  @media ${device.mobileS} {
    font-size: 16px;
  }
`;
const MemberName = styled.p`
  font-weight: bold;
  font-size: 17px;

  @media ${device.mobileS} {
    font-size: 16px;
  }
`;
const TitleName = styled.p`
  @media ${device.mobileS} {
    font-size: 13px;
  }
`;
const Team = styled.div`
  flex-basis: 25%;
  padding: 10px;
  @media ${device.mobileS} {
    padding: 10px;
  }
`;
const EmptyTwitter = styled.div`
  height: 20px;
`;
const LogosRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const Image = styled.img<{ isActive: boolean }>`
  border-radius: 50%;
  height: 120px;
  width: 120px;
  margin-bottom: 15px;
  @media ${device.mobileS} {
    height: 90px;
    width: 90px;
  }
  opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};
  &:hover {
    ${({ isActive }) =>
      !isActive &&
      'opacity: ${({ isActive }) => (isActive ? 1 : 0.8)}; cursor: pointer; transform: scale(1.05)'}
  }

  transition: all 0.2s ease-in-out;
`;

const ExplainerText = styled(motion.div)`
  font-size: 16px;
  text-align: center;
  height: 48px;
  margin-top: 16px;

  @media ${device.mobileS} {
    font-size: 14px;
  }
`;
export default function StakeCenterFold({}: Props) {
  return <EthereumWithdraw />;
}
